import React from 'react';
import { Col, Container, Form, Row } from 'reactstrap';

import C from '../C';
import DataStore from '../base/plumbing/DataStore';
import Login from '../base/youagain';
import KStatus from '../base/data/KStatus';
import SearchQuery from '../base/searchquery';

import ListLoad from '../base/components/ListLoad';
import PropControl from '../base/components/PropControl';

import { GreenLogin } from './greentag/GreenTagWidgets';


/**
 * A temporary certificate viewer
 */
function CertificatePage() {
	if (!Login.isLoggedIn()) return <GreenLogin />;

	let sq = null;
	// Filter by brand/agency
	const vertiser = DataStore.getUrlValue('brand');
	const agencyId = DataStore.getUrlValue('agency');
	const hasCertificate = DataStore.getUrlValue('hasCertificate');
	if (vertiser) {
		sq = SearchQuery.setProp(sq, 'vertiser', vertiser);
	}
	if (agencyId) {
		sq = SearchQuery.setProp(sq, 'agencyId', agencyId);
	}
	if (hasCertificate) {
		sq = SearchQuery.and(sq, 'certificateUrl:any OR certificateFile:any');
	}

	const q = sq && sq.query;
	const filter = DataStore.getUrlValue('filter');

	return (<Container>
		<h3>Offset / Impact Certificate List</h3>
		<Form className="border pl-2 pr-2 -pt-1">
			<label>Filter</label>
			<Row>
				<Col>
					<PropControl type="DataItem" itemType={C.TYPES.Advertiser} label prop="brand" />
				</Col>
				<Col>
					<PropControl type="DataItem" itemType={C.TYPES.Agency} label prop="agency" />
				</Col>
				<Col>
					<PropControl type="search" label="Keyword" prop="filter" />
				</Col>
				<Col>
					<PropControl type="checkbox" label="Has Certificate" prop="hasCertificate" />
				</Col>
			</Row>
		</Form>
		<ListLoad otherParams={{ filterByShares: true }}
			q={q}
			filter={filter}
			filterLocally
			type={C.TYPES.ImpactCredit}
			status={KStatus.PUBLISHED}
			// ListItem={TagListItem}            
			notALink
			pageSize={20}
			hasCsv
			// csvColumns={csvColumns}
		/>
	</Container>);
}

export default CertificatePage;
